import { render, staticRenderFns } from "./ProfileNavItem.vue?vue&type=template&id=769adfb4&scoped=true&"
import script from "./ProfileNavItem.vue?vue&type=script&lang=js&"
export * from "./ProfileNavItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNavItem.vue?vue&type=style&index=0&id=769adfb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769adfb4",
  null
  
)

export default component.exports